interface PageParams {
    pathname: string;
    generalKeys: string[];
    generalKeys_jp: string[];
    generalKeys_eu: string[];
    generalKeys_ph: string[];
    tabs: string[];
    theme?: string;
    sites: string[];
}

export const pageParams: PageParams = {
    pathname: 'rapid-pro-power-bank',
    generalKeys: ['pb501-x', 'EcoFlow RAPID Pro Power Bank 140W', 'EcoFlow RAPID Pro Power Bank 100'],
    generalKeys_jp: ['pb501-x', 'EcoFlow RAPID Pro Power Bank 140W', 'EcoFlow RAPID Pro Power Bank 100', 'rapid_pro_012'],
    generalKeys_eu: ['pb501-x', 'EcoFlow RAPID Pro Power Bank 140W', 'EcoFlow RAPID Pro Power Bank 100', 'product_rapid_pro_charging_dock'],
    generalKeys_ph: ['EcoFlow RAPID Pro Power Bank 140W', 'EcoFlow RAPID Pro Power Bank 100', 'rapid_pro_012'],
    tabs: ['product', 'support'],
    theme: 'black',
    sites: ['jp', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'us', 'ca', 'ph'],
};

export const pathname = pageParams.pathname;
export const generalKeys = pageParams.generalKeys;
export const tabs = pageParams.tabs;
export const theme = pageParams.theme;
export const sites = pageParams.sites;
